import {getConfig} from 'coreUtils/utils';
import {createCoreQueryBuilderConfig} from './coreQueryBuilderRules';

const getMaxInclude = (): number => {
	try {
		const {app} = getConfig();

		return app?.cmsAPI?.parameters?.maxInclude ?? 100;
	} catch {
		return 100;
	}
};

/**
 * Default core configuration contains ONLY mappings present in ALL brands.
 * Brand-specific mappings should be declared in brand configs.
 */
export const coreQueryBuilderConfig = createCoreQueryBuilderConfig(getMaxInclude);
